var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7132 6.28095L6.33818 2.78095L1.96318 6.28095C1.86062 6.36302 1.7429 6.4241 1.61673 6.46067C1.49057 6.49725 1.35843 6.50863 1.22787 6.49414C1.09732 6.47965 0.970888 6.43959 0.855811 6.37625C0.740733 6.3129 0.63926 6.22751 0.557184 6.12495C0.475107 6.02239 0.414036 5.90466 0.377457 5.7785C0.340877 5.65233 0.329506 5.5202 0.343992 5.38964C0.358477 5.25908 0.398537 5.13265 0.461883 5.01758C0.525229 4.9025 0.610621 4.80102 0.713184 4.71895L5.71318 0.718947C5.89055 0.576944 6.11098 0.499573 6.33818 0.499573C6.56539 0.499573 6.78582 0.576944 6.96318 0.718947L11.9632 4.71895C12.1703 4.88471 12.3031 5.12596 12.3324 5.38964C12.3616 5.65332 12.2849 5.91781 12.1192 6.12495C12.0371 6.22751 11.9356 6.3129 11.8206 6.37625C11.7055 6.43959 11.5791 6.47965 11.4485 6.49414C11.1848 6.5234 10.9203 6.44671 10.7132 6.28095Z",
    fill: "#056EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowBlue);
export default __webpack_public_path__ + "static/media/upArrowBlue.3cfa0440f283e2c95c94413476d458fe.svg";
export { ForwardRef as ReactComponent };